import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-login',
  imports: [ProgressSpinnerModule],
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class Login implements OnInit {
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.redirectToAuth();
  }
}
